<template>
  <div id="app">
    <Toast />
    <router-view />
    <ModalIdle v-if="isIdle" />
  </div>
</template>

<script>
import Toast from "primevue/toast/Toast.vue";
import ModalIdle from "./components/modals/ModalIdle";

export default {
  name: "app",
  components: {
    ModalIdle,
    Toast
  },
  computed: {
    isIdle() {
      if (this.$store.state.idleVue.isIdle === true) {
        window.location.href = "login";
      }
      return this.$store.state.idleVue.isIdle;
    }
  }
};
</script>

<style>
#app {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
.p-toast .p-toast-message.p-toast-message-success {
  background: var(--dark-expo) !important;
  border: solid var(--dark-expo-alpha) !important;
  border-width: 0 0 0 6px !important;
  color: var(--textactive) !important;
}

.p-toast .p-toast-message.p-toast-message-success .p-toast-message-icon,
.p-toast .p-toast-message.p-toast-message-success .p-toast-icon-close,
.p-toast .p-toast-message .p-toast-message-content .p-toast-message-text,
.p-toast
  .p-toast-message
  .p-toast-message-content
  .p-toast-message-text
  .p-toast-detail {
  color: var(--textactive) !important;
}
</style>
